import { retrieveToken } from '../storage';
import {
  wrapFetch,
  apiFetch,
  apiError,
  SALVATAGGIO_DATI_NON_CORRETTI,
} from './api';

const BASE_URL = process.env.REACT_APP_BACKEND_ENDPOINT;

export const getModelli = (
  hidden,
  gruppoId,
  isConsulenteView,
  stato,
  page,
  size,
  sortby,
) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/manuali';
  let query =
    '?' +
    'page=' +
    page +
    '&personalizzato.equals=true' +
    '&size=' +
    size +
    '&sort=' +
    sortby +
    '&' +
    sortby +
    '.dir=ASC' +
    '&isModello.equals=true';

  if (isConsulenteView) {
    query += '&stato.equals=PUBBLICATO&hidden.equals=false';
  } else {
    query = query + '&hidden.equals=' + hidden;
  }
  if (gruppoId !== null && gruppoId !== -1) {
    query = query + '&gruppoId.equals=' + gruppoId;
  }
  if (stato !== null && stato !== undefined) {
    query = query + '&stato.equals=' + stato;
  }
  const URL = BASE_URL + PATH + query;
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};
export const getModelliFiltered = (
  hidden,
  gruppoId,
  isConsulenteView,
  stato,
  page,
  size,
  sortby,
  idModello,
  titolo,
  regolamenti,
) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/manuali';
  let query = `?page=${page}&personalizzato.equals=true&size=${size}&sort=${sortby}&${sortby}.dir=ASC&isModello.equals=true`;

  if (isConsulenteView) {
    query += '&stato.equals=PUBBLICATO&hidden.equals=false';
  } else {
    query = query + '&hidden.equals=' + hidden;
  }
  if (gruppoId !== null && gruppoId !== -1) {
    query = query + '&gruppoId.equals=' + gruppoId;
  }
  if (stato !== null && stato !== undefined) {
    query = query + '&stato.equals=' + stato;
  }
  if (idModello !== null && idModello !== '') {
    query = query + '&id.equals=' + idModello;
  }
  if (regolamenti !== null && regolamenti !== '') {
    query += `&regolamenti.contains=${encodeURIComponent(regolamenti)}`;
  }
  if (titolo !== null && titolo !== '') {
    query += `&titolo.contains=${encodeURIComponent(titolo)}`;
  }
  const URL = BASE_URL + PATH + query;
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};

export const getModelliCount = (hidden, gruppoId, isConsulenteView, stato) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/manuali/count';
  let query = '?personalizzato.equals=true&isModello.equals=true';

  if (isConsulenteView) {
    query += '&stato.equals=PUBBLICATO&hidden.equals=false';
  } else {
    query = query + '&hidden.equals=' + hidden;
  }
  if (gruppoId !== null && gruppoId !== -1) {
    query = query + '&gruppoId.equals=' + gruppoId;
  }
  if (stato !== null && stato !== undefined) {
    query = query + '&stato.equals=' + stato;
  }
  const URL = BASE_URL + PATH + query;
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};

export const getModelliCountFiltered = (
  hidden,
  gruppoId,
  isConsulenteView,
  stato,
  idModello,
  titolo,
  regolamenti,
) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/manuali/count';
  let query = '?personalizzato.equals=true&isModello.equals=true';

  if (isConsulenteView) {
    query += '&stato.equals=PUBBLICATO&hidden.equals=false';
  } else {
    query = query + '&hidden.equals=' + hidden;
  }
  if (gruppoId !== null && gruppoId !== -1) {
    query = query + '&gruppoId.equals=' + gruppoId;
  }
  if (stato !== null && stato !== undefined) {
    query = query + '&stato.equals=' + stato;
  }
  if (idModello !== null && idModello !== '') {
    query = query + '&id.equals=' + idModello;
  }
  if (regolamenti !== null && regolamenti !== '') {
    query += `&regolamenti.contains=${encodeURIComponent(regolamenti)}`;
  }
  if (titolo !== null && titolo !== '') {
    query += `&titolo.contains=${encodeURIComponent(titolo)}`;
  }
  const URL = BASE_URL + PATH + query;
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};

export const getManuale = (manualeId) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/manuali/' + manualeId;
  const URL = BASE_URL + PATH;
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};

export const getFlagControlliSemplificatiManualeFromId = (manualeId) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/manuali/is-semplificato/' + manualeId;
  const URL = BASE_URL + PATH;
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};

export const updateModello = (modello) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/manuali';
  const URL = BASE_URL + PATH;
  return wrapFetch(
    apiFetch(URL, {
      method: 'PUT',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
      body: JSON.stringify(modello),
    }),
    apiError({
      400: SALVATAGGIO_DATI_NON_CORRETTI,
      404: 'Errore salvataggio: modello non trovato.',
    }),
  );
};

export const cancellaModello = (modelloId, hidden) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/manuali/cancella';
  const URL = BASE_URL + PATH;
  const requestBody = {
    id: modelloId,
    hidden: hidden,
  };
  return wrapFetch(
    apiFetch(URL, {
      method: 'PUT',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
      body: JSON.stringify(requestBody),
    }),
    apiError({
      // Error 404 if ID does not correspond to an existing record:
      400: SALVATAGGIO_DATI_NON_CORRETTI,
      404: SALVATAGGIO_DATI_NON_CORRETTI,
    }),
  );
};

export const creaManualePersonalizzato = (
  esercizioCommercialeId,
  manualeBaseId,
  consulenteId,
  hasChapters,
  isControlloSemplificato,
  tipologiaRevisione,
) => {
  const token = retrieveToken();
  const PATH = '/api/manuali/personalizzati';
  const URL = BASE_URL + PATH;
  const authtoken = 'Bearer '.concat(token);
  const requestBody = {
    manualeBaseId: manualeBaseId,
    consulenteId: consulenteId,
    esercizioCommercialeId: esercizioCommercialeId,
    useChapters: hasChapters,
    controlliSemplificati: isControlloSemplificato,
    tipologiaRevisione,
  };
  return wrapFetch(
    apiFetch(URL, {
      method: 'POST',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
      body: JSON.stringify(requestBody),
    }),
    apiError({
      400: 'Creazione manuale non riuscita: i dati non sono corretti.',
      404: 'Creazione manuale non riuscita: i dati non sono corretti.',
    }),
  );
};

export const creaModelloPersonalizzato = (
  manualeBaseId,
  gruppoId,
  hasChapters,
  isControlloSemplificato,
  tipologiaRevisione,
) => {
  const token = retrieveToken();
  const PATH = '/api/modelli/personalizzati';
  const URL = BASE_URL + PATH;
  const authtoken = 'Bearer '.concat(token);
  const requestBody = {
    manualeBaseId: manualeBaseId,
    gruppoId: gruppoId,
    useChapters: hasChapters,
    controlliSemplificati: isControlloSemplificato,
    tipologiaRevisione,
  };
  return wrapFetch(
    apiFetch(URL, {
      method: 'POST',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
      body: JSON.stringify(requestBody),
    }),
    apiError({
      400: 'Creazione modello non riuscita: i dati non sono corretti.',
      404: 'Creazione modello non riuscita: i dati non sono corretti.',
    }),
  );
};

export const clonaModelliPersonalizzati = (gruppoId, brandId, ids) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/modelli/personalizzati/clonazione_multipla';
  const URL = BASE_URL + PATH;
  const requestBody = {
    gruppoId,
    brandId,
    modelliIds: ids,
  };
  return wrapFetch(
    apiFetch(URL, {
      method: 'POST',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
      body: JSON.stringify(requestBody),
    }),
    apiError({
      400: 'Clonazione modelli non riuscita: i dati non sono corretti.',
    }),
  );
};
